import { createContext, useContext, useState, ReactNode } from 'react'

export interface Customer {
  id?: string
  name?: string
  cpf?: string
  phone?: string
  email?: string
  maritalStatus?: string
  birthDate?: string
  address?: {
    zipCode: string
    state: string
    city: string
    neighborhood: string
    street: string
    number: string
    complement?: string
  }
  bankAccount?: {
    bank: string
    agency: string
    account: string
    accountType: string
  }
}

export interface Despesa {
  valor_padrao_mutavel: boolean
  codigo: number
  grupo: string
  financiada: boolean
  tipo: number
  inclusa: boolean
  numero_item: number
  obrigatoria: boolean
  valor_calculado: number
  valor_maximo: number
  valor_minimo: number
}

export interface OperacoesCredito {
  sucesso: boolean
  mensagem_erro: string
  prazo: number
  metodo: string
  codigo_tabela_financiamento: string
  descricao_tabela_financiamento: string
  codigo_produto: string
  descricao_produto: string
  primeiro_vencimento: string
  ultimo_vencimento: string
  despesas: Despesa[]
  taxa_apropriacao_anual: number
  taxa_apropriacao_mensal: number
  taxa_cet_anual: number
  taxa_cet_mensal: number
  taxa_referencia_anual: number
  taxa_referencia_mensal: number
  valor_bruto: number
  valor_cliente: number
  valor_financiado: number
  valor_solicitado: number
  valor_iof: number
  valor_liquido: number
  valor_parcela: number
  refinanciamentos: any[]
}

export interface ProposalData {
  operacoes_credito: OperacoesCredito
  customerId: string
}

interface PanContextType {
  customer: Customer | null
  setCustomer: (customer: Customer | null) => void
  proposal: ProposalData | null
  setProposal: (proposal: ProposalData | null) => void
  preTransactionId: string | null
  setPreTransactionId: (id: string | null) => void
  transactionId: string | null
  setTransactionId: (id: string | null) => void
}

const PanContext = createContext<PanContextType | undefined>(undefined)

export function PanProvider({ children }: { children: ReactNode }) {
  const [customer, setCustomer] = useState<Customer | null>(null)
  const [proposal, setProposal] = useState<ProposalData | null>(null)
  const [preTransactionId, setPreTransactionId] = useState<string | null>(null)
  const [transactionId, setTransactionId] = useState<string | null>(null)

  return (
    <PanContext.Provider
      value={{
        customer,
        setCustomer,
        proposal,
        setProposal,
        preTransactionId,
        setPreTransactionId,
        transactionId,
        setTransactionId,
      }}
    >
      {children}
    </PanContext.Provider>
  )
}

export function usePanContext() {
  const context = useContext(PanContext)
  if (!context) {
    throw new Error('usePanContext must be used within a PanProvider')
  }
  return context
}
